module.exports = __webpack_public_path__ + "static/media/48.53dbd5a3.png";